import { render } from "./XhsAccountManagement.vue?vue&type=template&id=05a82d43&scoped=true"
import script from "./XhsAccountManagement.vue?vue&type=script&lang=js"
export * from "./XhsAccountManagement.vue?vue&type=script&lang=js"

import "./XhsAccountManagement.vue?vue&type=style&index=0&id=05a82d43&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a82d43"]])

export default __exports__